import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';
import { TrustAuthorisationRequestType } from '../../Constants/Enums/Customer/TrustAuthorisationRequestType';
import { TrustRemovalReason } from '../../Constants/Enums/Customer/TrustRemovalReason';
import { TrustAuthorisationRequestModel } from '../../Models/Models/Customer/TrustAuthorisationRequestModel';
import { AuthorisationStatus } from '../../Models/Models/Common/AuthorisationStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class TrustAuthorisationRequestsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(customerId: number, organisationId: number, type: TrustAuthorisationRequestType, reason: TrustRemovalReason): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/TrustAuthorisationRequests/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, organisationId: organisationId, type: type, reason: reason }

    return AjaxWrapper.post<ValidationStatus, any>(url, data);
  }
  public get(organisationId: number, removalReason: TrustRemovalReason, status: AuthorisationStatus, trustMemberIds: Array<number>): Promise<Array<TrustAuthorisationRequestModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/TrustAuthorisationRequests/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { organisationId: organisationId, removalReason: removalReason, status: status, trustMemberIds: trustMemberIds }

    return AjaxWrapper.get<Array<TrustAuthorisationRequestModel>, any>(url, data);
  }
}

